export interface UserDataCache {
  firstName?: string
  lastName?: string
  email?: string
  phone?: string
  dateOfBirth?: string
  ssn?: string
  address?: {
    street?: string
    city?: string
    state?: string
    zipCode?: string
  }
  propertyAddress?: {
    street?: string
    city?: string
    state?: string
    zipCode?: string
  }
  [key: string]: any
}

const CACHE_KEY = 'user_data_cache'

export const dataPersistence = {
  get: (key: string): any => {
    try {
      const cache = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}')
      return cache[key]
    } catch {
      return undefined
    }
  },

  set: (key: string, value: any): void => {
    try {
      const cache = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}')
      cache[key] = value
      localStorage.setItem(CACHE_KEY, JSON.stringify(cache))
    } catch (error) {
      console.error('Failed to save data:', error)
    }
  },

  getAll: (): UserDataCache => {
    try {
      return JSON.parse(localStorage.getItem(CACHE_KEY) || '{}')
    } catch {
      return {}
    }
  },

  merge: (data: Partial<UserDataCache>): void => {
    try {
      const cache = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}')
      const merged = { ...cache, ...data }
      localStorage.setItem(CACHE_KEY, JSON.stringify(merged))
    } catch (error) {
      console.error('Failed to merge data:', error)
    }
  },

  clear: (): void => {
    localStorage.removeItem(CACHE_KEY)
  },

  autoFill: (formData: Record<string, any>): Record<string, any> => {
    const cache = dataPersistence.getAll()
    const filled = { ...formData }
    
    Object.keys(cache).forEach(key => {
      if (cache[key] && !filled[key]) {
        filled[key] = cache[key]
      }
    })
    
    if (cache.address && !filled.address) {
      filled.address = cache.address
    }
    
    if (cache.propertyAddress && !filled.propertyAddress) {
      filled.propertyAddress = cache.propertyAddress
    }
    
    return filled
  }
}

